import type { TProjectPageView } from "../model/types";

export function chapterParams(prev: URLSearchParams, chapterId: number) {
  const params = new URLSearchParams(prev);
  params.set("tab", "document");
  params.set("chapterId", chapterId.toString());
  params.delete("chapterSubsection");
  params.delete("view");
  return params;
}

export function viewParams(prev: URLSearchParams, view: TProjectPageView) {
  const params = new URLSearchParams(prev);
  if (params.get("tab") === "presentation") params.set("tab", "document");
  params.set("view", view);
  params.delete("chapterId");
  params.delete("chapterSubsection");
  return params;
}

export function homeParams(prev: URLSearchParams) {
  const params = new URLSearchParams(prev);
  params.set("tab", "overview");
  params.delete("chapterId");
  params.delete("chapterSubsection");
  params.delete("view");
  return params;
}

export function presentationParams() {
  return new URLSearchParams({ tab: "presentation" });
}
